import { render, staticRenderFns } from "./leads-form-edit.vue?vue&type=template&id=54d866c4&"
import script from "./leads-form-edit.vue?vue&type=script&lang=js&"
export * from "./leads-form-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports